import { render, staticRenderFns } from "./DocumentDefinitionsOverview.vue?vue&type=template&id=48f04472&scoped=true"
import script from "./DocumentDefinitionsOverview.vue?vue&type=script&lang=js"
export * from "./DocumentDefinitionsOverview.vue?vue&type=script&lang=js"
import style0 from "./DocumentDefinitionsOverview.vue?vue&type=style&index=0&id=48f04472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f04472",
  null
  
)

export default component.exports